import {memo, useEffect, useState} from "react";
import styled, {createGlobalStyle} from "styled-components";
import {delay, pub, useEffectAsync} from "../utils/common";
import {Button, Carousel, Image, Space, Modal, Divider} from "@arco-design/web-react";
import {IconEmail, IconLink, IconRobot, IconThunderbolt, IconUser, IconWechat} from "@arco-design/web-react/icon";
import {IcrdFirends, IcrdFirendsEN, ThePics, ThePicsEN} from "./MainPageData";
import useWindowDimensions from "../utils/useWindowDimensions";
import {Link} from "react-router-dom";
import XIF from "../components/utils/XIF";


const LogoHead = memo(() => <>
  <div className="flex mb-1.5">
    <div className="cursor-pointer flex">
      <img className="w-[50px] h-[50px] rounded-[10px]"
           alt="logo"
           src={pub`/assets/images/footer/logo.png`}/>
      <h2 className="mt-[8px] ml-[8px] font-bold text-2xl text-white">CoChiper</h2>
    </div>
  </div>
</>)

export const showKefuDialog = () => {
  Modal.success({
    title: "24小时在线客服",
    okText: "知道了",
    content: <div>
      <div className="flex w-full justify-center">
        <Image className="mr-4 w-[250px]" src={pub`/assets/images/boss_qr.jpg`} alt="qr"/>
      </div>
      <div className="flex w-full justify-center mt-4">
        <a href="mailto:cma@zhenwo.ai"><IconEmail/> 邮箱：cma@zhenwo.ai</a>
      </div>
    </div>
  })
}

const TitlePanel = memo(({isUk = false}) => {
    const titleText = isUk
      ? "World's first AI-driver chip development platform！"
      : "全球首个AI大模型驱动的芯片开发平台！"
    const {isMobile} = useWindowDimensions()
    const [title, setTitle] = useState("")
    const [isAIKefuShow, setAIkefuShow] = useState(false)
    useEffectAsync(async () => {
      const words = titleText.split('')
      let line = ""
      for (const word of words) {
        line += word
        setTitle(line)
        await delay(isUk ? 30 : 70)
      }
    }, []);
    return <div className="w-full flex justify-center ">
      <AIKefuPanel isUk={isUk}
                   show={isAIKefuShow}
                   setShow={setAIkefuShow}/>
      <div>
        <h1 className="m-8 text-white font-bold text-[3em] text-center">{title}</h1>
        <div className="w-full flex justify-center ">
          <div className={`${isMobile ? 'w-[80%]' : ''}`}>
            <Space className="w-full" size="medium" direction={isMobile ? 'vertical' : ''}>
              <XButton
                onClick={() => {
                  window.open(`https://cochiper.${isUk ? 'ai' : 'com'}/my-chiper`, "_blank")
                }}
                style={{
                  height: "45px",
                  fontSize: "1.2em",
                  color: 'blueviolet',
                  fontWeight: "bold",
                  width: "100%"
                }}>
                <IconThunderbolt/>{isUk ? 'Visit CoChiper' : '访问 CoChiper'}
              </XButton>
              <XButton
                onClick={() => setAIkefuShow(true)}
                style={{
                  height: "45px",
                  fontSize: "1.2em",
                  color: 'white',
                  background: "#da3c81",
                  width: "100%"
                }}>
                <IconRobot/>
                {isUk ? 'AI Customer Service' : 'AI客服'}
              </XButton>
            </Space>
          </div>
        </div>
        <p className={`m-8 mt-6 mb-1 text-white text-center leading-[1.8]
       text-[1.2em] ${!isMobile ? 'pl-[10%] pr-[10%]' : ''}`}>
          {isUk
            ?
            `CoChiper is centered around AI large models, integrating RTL code auto-generation, 
          automated simulation, and physical implementation into one platform. 
          It includes commonly used IPs such as RISC-V and bus interfaces like SPI/UART.
           Through various intelligent agents and workflows, 
           CoChiper helps you improve efficiency and explore endless possibilities.`
            :
            `CoChiper以AI大模型为核心，集RTL代码自动生成，自动仿真及物理实现与一体，
          集成了常见的IP如RISC-V和SPI/UART等总线接口，并通过各种智能体和工作流，帮助您提升效率，并探索无尽可能。`
          }
        </p>
      </div>
    </div>
  }
)


const ImgArea = memo(({isUk = false}) => {

  const [picIndex, setPicIndex] = useState(0)
  const [kehuIndex, setKehuIndex] = useState(0)
  const {isMobile} = useWindowDimensions()

  return <div className="m-2 mt-4">
    <div className="ml-8 mr-8"><LogoHead/></div>
    <TitlePanel isUk={isUk}/>
    <div className="w-full flex justify-center">
      <div className="m-5 mt-8 rounded-[30px]  max-w-[85%]">
        <div className="p-6 rounded-[10px]">
          <Carousel
            autoPlay
            animation='card'
            indicatorPosition='outer'
            currentIndex={picIndex}
            onChange={setPicIndex}
            showArrow='never'
          >
            {(isUk ? ThePicsEN : ThePics).map((pic, index) => (
              <div className="mb-2 ">
                <div key={index} className="rounded-[20px] bg-white pt-6 pb-1">
                  <div className="w-full flex justify-center ">
                    <p className="mb-2 font-bold text-[1.5em]">{pic.title}</p>
                  </div>
                  <div className={`w-full flex justify-center ${isMobile ? 'pl-5 pr-5' : 'pl-20 pr-20'} text-center`}>
                    <p className="mb-4 leading-[1.8]">{pic.desc}</p>
                  </div>
                  <div className="m-6 mb-8 rounded-[20px]  flex justify-center">
                    <Image className="shadow-[0_0_10px_5px_skyblue]" src={pic.url} alt={'img'} style={{borderRadius: "20px"}}/>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
    <div className="w-full flex justify-center ">
      <div className="m-5 mt-8 w-[85%] ">
        <div className="w-full">
          <p className="mb-4 font-bold text-[2.2em] text-white">
            {isUk ? 'Customer cases：' : '客户案例：'}
          </p>
        </div>
        <div className="rounded-[20px] p-4 mb-6 ">
          <Carousel
            autoPlay
            animation='card'
            indicatorPosition='outer'
            currentIndex={kehuIndex}
            onChange={setKehuIndex}
            showArrow='never'
          >
            {(isUk ? IcrdFirendsEN : IcrdFirends).map((pic, index) => (
              <div className="mb-2">
                <div className="mr-6 p-1 bg-white rounded-[20px] w-full">
                  <div key={index} className="flex justify-center">
                    <Image style={{borderRadius: "20px"}} src={pic.url} alt={'friend'}/>
                  </div>
                  <Divider/>
                  <div className={`m-6 ${isMobile ? '' : 'flex'}`}>
                    <p className="text-[1.2em]">
                      {isUk ? 'Customer' : '客户'} <IconUser/> <strong>{pic.title}</strong>
                    </p>
                    <XIF condition={pic.website && !isUk}>
                      <div className="mt-[0.2em] underline">
                        <IconLink className={`mr-1 ${isMobile ? '' : 'ml-4'}`}/><Link to={pic.website}>{pic.website}</Link>
                      </div>
                    </XIF>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  </div>
})


const EndArea = memo(({isUk = false}) => {

  const {isMobile} = useWindowDimensions()

  const QRDiv = memo(({src, title}) => {
    return <div className="w-[180px] mb-2">
      <Image className="mr-4" src={src} alt="qr"/>
      <p className="mt-3 text-center text-[1.2em]">{title}</p>
    </div>
  })

  if (isUk) {
    return <div className={`bg-black p-8 ${!isMobile ? 'pl-20 pr-20' : ''} text-white`}>
      <div className="tracking-[0.2em] mr-8 mb-8 ">
        <p className="text-[1.2em] mb-2">Contact us（24h)：</p>
        <Link to="mailto:cma@zhenwo.ai"><IconEmail/> E-MAIL：cma@zhenwo.ai</Link>
      </div>
    </div>
  }
  return <div className={`bg-black p-8 ${!isMobile ? 'pl-20 pr-20' : ''} text-white`}>
    <div className={`${isMobile ? '' : 'flex '}`}>
      <div className={`${!isMobile ? 'w-[40%] pr-6' : 'w-full'}`}>
        <img className="mb-2 h-[150px] object-contain" alt="logo"
             src={pub`/assets/images/footer/865.png`}/>
        <div className="mb-10">
          <p className="mb-4 tracking-[0.2em]">上海芯事达企业管理咨询有限公司</p>
          <div className="flex mb-4">
            <Space className="text-[1.2em]" size="medium">
              <Link to="https://zhenwoai.com/conceal">隐私政策</Link>
              <Link to="https://zhenwoai.com/agree">用户协议</Link>
            </Space>
          </div>
          <Link to="https://beian.miit.gov.cn/">© 2024 真我AI 沪ICP备2023024407号-6</Link>
        </div>
      </div>

      <div className={`flex-col ${isMobile ? 'w-full' : 'w-[60%]  pl-10'}`}>
        <div className="tracking-[0.2em] mr-8 mb-8 ">
          <p className="text-[1.2em] mb-2">联系我们：</p>
          <Link to="mailto:cma@zhenwo.ai"><IconEmail/> 邮箱：cma@zhenwo.ai</Link>
        </div>
        <div className="flex w-full">
          <QRDiv title="公众号" src={pub`/assets/images/gzh_qr.jpg`}/>
          <QRDiv title="用户群" src={pub`/assets/images/user_group_qr.jpg`}/>
          <QRDiv title="客服（24h）" src={pub`/assets/images/boss_qr.jpg`}/>
        </div>
      </div>
    </div>
  </div>
})

const AIKefuPanel = memo(({isUk = false, show, setShow}) => {
  return <Modal visible={show}
                footer={null}
                onCancel={setShow}
                style={{
                  width: "90vw",
                  height: "90vh",
                }}>
    <div style={{
      height: "calc(90vh - 40px)"
    }}>
      <iframe className="rounded-[5px]"
              title="aikefu"
              src={`https://zhenwoai.cn/v2/taskflow/eb592a12-01a9-4e3f-b752-e10401038421/chat?anon=1&embedded=1`}
              width="100%"
              height="100%"
              allowFullScreen
              sandbox="allow-forms allow-same-origin allow-scripts allow-downloads"
      />
    </div>
  </Modal>
})

const MainPage = memo(() => {
  const query = new URLSearchParams(window.location.search)
  const area = query.get('area')
  const isUk = area === 'uk'
  return <>
    <GlobalStyle/>
    <Root>
      <ImgArea isUk={isUk}/>
      <EndArea isUk={isUk}/>
    </Root>
  </>
})

export default MainPage

const Root = styled.div`
`

const GlobalStyle = createGlobalStyle`
    body {
        background: radial-gradient(circle, #4e6365, #182c3d); /* 径向渐变：深绿色到浅绿色 */
        margin: 0;
        box-sizing: border-box;
        letter-spacing: 1px;
    }
`

const XButton = styled(Button)`
    border-radius: 50px;
    height: 36px;
    padding: 6px 20px 10px 20px;
`